import {
  AUTHORITY_VALIDATION_RULES,
  CONTRIBUTOR_NAME_TYPE_MAPPING,
  isAuthorityTypeAllowed
} from '../constants';

// Validate authority link based on existing rules
export const validateAuthorityLink = (fieldPath, authorityRecord, formValues, fieldIndex) => {
  const validationRule = AUTHORITY_VALIDATION_RULES[fieldPath];

  if (!validationRule) {
    // If no specific rule, allow all authority types
    return { isValid: true };
  }

  // For contributor fields, check contributor name type compatibility
  if (fieldPath === 'contributors.name' && validationRule.requiresContributorType) {
    return validateContributorAuthorityLink(authorityRecord, formValues, fieldIndex);
  }

  // For other fields, check if authority type is allowed
  const authorityType = authorityRecord.headingType || authorityRecord.authRefType;
  if (!isAuthorityTypeAllowed(fieldPath, authorityType)) {
    return {
      isValid: false,
      errorCode: 'INCOMPATIBLE_AUTHORITY_TYPE',
      errorMessage: `Cannot link ${fieldPath} field to ${authorityType} authority record`,
    };
  }

  return { isValid: true };
};

// Validate contributor-specific authority linking
const validateContributorAuthorityLink = (authorityRecord, formValues, fieldIndex) => {
  const contributorNameTypeId = formValues?.instanceData?.contributors?.[fieldIndex]?.contributorNameTypeId;

  if (!contributorNameTypeId) {
    return {
      isValid: false,
      errorCode: 'MISSING_CONTRIBUTOR_TYPE',
      errorMessage: 'Contributor name type is required for authority linking',
    };
  }

  // This would need access to controlledVocab to get the actual name type
  // For now, we'll allow the link and let the existing validation handle it
  return { isValid: true };
};

// Check if field supports authority linking (from existing AUTHORITY_LINKED_FIELDS)
export const isFieldAuthorityLinkable = (fieldPath) => {
  return Object.keys(AUTHORITY_VALIDATION_RULES).includes(fieldPath);
};
